import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';
import toast from 'react-hot-toast';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // Estado inicial
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      // Acciones
      login: async (credentials) => {
        try {
          set({ isLoading: true });

          // DEBUG COMPLETO
          console.log('🚀 INTENTANDO LOGIN...');
          console.log('📡 URL completa:', api.defaults.baseURL + '/auth/login');
          console.log('📦 Datos:', credentials);
          console.log('📋 Headers:', api.defaults.headers.common);

          const response = await api.post('/auth/login', credentials);

          console.log('✅ LOGIN EXITOSO:', response.data);

          if (response.data.success) {
            const { token, user } = response.data.data;

            // Guardar token en localStorage y headers de axios
            localStorage.setItem('token', token);
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            set({
              user,
              token,
              isAuthenticated: true,
              isLoading: false
            });

            // toast.success(`¡Bienvenido, ${user.name}!`);
            // return { success: true };
          }
        } catch (error) {
          console.error('❌ ERROR COMPLETO EN LOGIN:');
          console.error('🔗 URL que falló:', error.config?.url);
          console.error('🔧 Método:', error.config?.method);
          console.error('📊 Status HTTP:', error.response?.status);
          console.error('📄 Response completa:', error.response);
          console.error('🔍 Request completo:', error.config);
          console.error('📝 Mensaje de error:', error.message);

          set({ isLoading: false });
          const message = error.response?.data?.message || 'Error en el login';
          toast.error(message);
          return { success: false, message };
        }
      },

      logout: () => {
        // Limpiar token
        localStorage.removeItem('token');
        delete api.defaults.headers.common['Authorization'];

        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false
        });

        // toast.success('Sesión cerrada correctamente');
      },

      verifyToken: async () => {
        try {
          const token = localStorage.getItem('token');

          if (!token) {
            return false;
          }

          // Configurar header de autorización
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

          const response = await api.post('/auth/verify');

          if (response.data.success) {
            const { user } = response.data.data;

            set({
              user,
              token,
              isAuthenticated: true,
              isLoading: false
            });

            return true;
          }
        } catch (error) {
          console.error('Error verificando token:', error);
          get().logout();
          return false;
        }
      },

      updateProfile: async (profileData) => {
        try {
          set({ isLoading: true });

          const response = await api.put('/auth/profile', profileData);

          if (response.data.success) {
            const { user } = response.data.data;

            set({
              user,
              isLoading: false
            });

            toast.success('Perfil actualizado correctamente');
            return { success: true };
          }
        } catch (error) {
          set({ isLoading: false });
          const message = error.response?.data?.message || 'Error actualizando perfil';
          toast.error(message);
          return { success: false, message };
        }
      },

      changePassword: async (passwordData) => {
        try {
          set({ isLoading: true });

          const response = await api.put('/auth/change-password', passwordData);

          if (response.data.success) {
            set({ isLoading: false });
            toast.success('Contraseña cambiada correctamente');
            return { success: true };
          }
        } catch (error) {
          set({ isLoading: false });
          const message = error.response?.data?.message || 'Error cambiando contraseña';
          toast.error(message);
          return { success: false, message };
        }
      },

      // Getters computados
      isAdmin: () => {
        const { user } = get();
        return user?.role === 'admin';
      },

      isScout: () => {
        const { user } = get();
        return user?.role === 'scout';
      },

      getUserName: () => {
        const { user } = get();
        return user?.name || 'Usuario';
      },

      clearError: () => {
        set({ error: null });
      },

      setLoading: (loading) => {
        set({ isLoading: loading });
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated
      })
    }
  )
);

export default useAuthStore;